module.exports = __webpack_public_path__ + "img/calendar-alt-solid.01864e1.svg";